import { Button, ButtonGroup, Stack } from '@chakra-ui/react';
import { ABN, SuperFundResponse } from '@zap-onboard/api-client';
import { inputs } from '@zap-onboard/web-components';
import { FormProvider, useForm } from 'react-hook-form';
import { SuperChoiceNameAutocomplete } from '../../../components/Flows/TaskManager/TaskTypes/SuperChoiceTask/APRAOrRSA/SuperChoiceNameAutocomplete';
import { z } from '../../../helpers/schema';
import { useHandler } from '../../../hooks/useHandlerMutation';
import { onError } from '../../../libs/errorLib';

export const NominateSuperFundFormSchema = z.object({
  // NOTE: This is a super hack until namespacing react hook form is setup
  superChoice: z.object({
    fundName: z.string().min(1, { message: 'Please select a fund' }),
    abn: z.valueObject(z.string(), ABN),
    usi: z.string().min(1, { message: 'Please select a fund' }),
  }),
});

export const NominateSuperFundForm = ({
  fund,
  after,
}: {
  fund?: SuperFundResponse;
  after?: () => unknown;
}) => {
  const formMethods = useForm<z.infer<typeof NominateSuperFundFormSchema>>({
    defaultValues: {
      superChoice: {
        abn: fund?.abn?.asJSON() ?? '',
        usi: fund?.usi ?? '',
        fundName: fund?.name ?? '',
      },
    },
    resolver: z.zodResolver(NominateSuperFundFormSchema),
  });
  const { setValue, handleSubmit } = formMethods;

  const [update, isUpdating] = useHandler(
    (api) => api.business().updateBusinessNominatedSuper,
    {
      always: { onError },
      whenMounted: { onSuccess: after },
      invalidates: () => [['BUSINESS_NOMINATED_SUPER_FUND'], ['BUSINESS']],
    },
  );

  const onSubmit = handleSubmit(
    async ({ superChoice: { fundName, usi, abn } }) => {
      await update({ provider: 'MANUAL', fund: { abn, usi, name: fundName } });
    },
  );

  return (
    <FormProvider {...formMethods}>
      <Stack mb={6}>
        <SuperChoiceNameAutocomplete
          isDisabled={false}
          onPicked={({ abn, usi, productName }) => {
            setValue('superChoice.fundName', productName);
            setValue('superChoice.usi', usi);
            setValue('superChoice.abn', abn?.asJSON());
          }}
        />
        <inputs.TextInput isReadOnly label="ABN" name="superChoice.abn" />
        <inputs.TextInput isReadOnly label="USI" name="superChoice.usi" />
      </Stack>

      <ButtonGroup>
        <Button isLoading={isUpdating} onClick={onSubmit}>
          Save
        </Button>
      </ButtonGroup>
    </FormProvider>
  );
};
